module.exports = __webpack_public_path__ + "img/Christoph.a92b7d46.png";